module.exports = __webpack_public_path__ + "static/img/bzfw.8aa025be.png";